import { CashbackDetails } from "@Routes/CashbackLinks";
import { Index as MgmMainPage } from "@Routes/MemberGetMemberLinks";
import { scrollToCbBrandsList } from "@Constants/PortalConstants";
import { urlFormat } from "@Components/Modules/Helpers";

export enum MgmPhoneVerificationActionType {
  Undefined = 0,

  GoToCashbackDashboard = 1,

  GoToMGMDashboard = 2,

  ScrollToCashbackBrands = 3,
}

export const MgmUserCommunicationAction = (actionType: number) => {
  switch (actionType) {
    case MgmPhoneVerificationActionType.GoToCashbackDashboard: {
      return CashbackDetails;
    }
    case MgmPhoneVerificationActionType.ScrollToCashbackBrands: {
      return urlFormat(CashbackDetails, { [scrollToCbBrandsList]: true }, true);
    }
    case MgmPhoneVerificationActionType.GoToMGMDashboard: {
      return MgmMainPage;
    }
    default:
      return undefined;
  }
};
